export default "__VITE_ASSET__DgIaFy4A__"